<template lang="">
    <div ref="loadingall">
		<router-view></router-view>
	</div>
</template>
<script>
import { useAuthStore, useUtilsStore } from "@/store";
export default {
	data() {
		const authStore = useAuthStore();
		return {
			serviceId :  this.$route.query.service_id || authStore.serviceId,
			redirectUrl : this.$route.query.redirect_url || authStore.redirectUrl,
			accountName : this.$route.query.account_name,
			autoRedirect : this.$route.query.auto_redirect,
			relateAccount : this.$route.query.relate_account,
			action : this.$route.query.action,
		}
	},
	async mounted() {
		
		const authStore = useAuthStore();
		
		authStore.serviceId = this.serviceId;
		authStore.redirectUrl = this.redirectUrl;
		authStore.autoRedirect = this.autoRedirect;
		if(this.$route.path === "/verify"){
			authStore.relateAccount = this.relateAccount;
			authStore.action = this.action;
            // trường hợp đối tác truyền sang tài khoản khác với tài khoản đang có phiên đăng nhập thì logout tk đang đăng nhập
            if (this.accountName && authStore.userInfoMyVTC && authStore.userInfoMyVTC.AccountName && this.accountName != authStore.userInfoMyVTC.AccountName) {
				authStore.logout();
                authStore.username = this.accountName;
				this.$router.push({ name: 'password', params: {} });
				return;
            }
		}


		if (authStore.CUID) {
			let loader = this.$loading.show({
				// Optional parameters
				container: this.$refs.loadingall,
				canCancel: false,
			});
			authStore.loginByCuid()
				.then((response) => {
					loader.hide();
					if (response.ResponseCode > 0) {
						authStore.serviceName = response.Data.ServiceName;
						authStore.loginSuccess(this.$router, response.Data.Code);
						return;
					}
					authStore.logout();
					return;
				})
				.catch((error) => {
					console.error(error);
				});
		}
		else if (this.accountName) {
			authStore.username = this.accountName;
			this.$router.push({ name: 'password', params: {} });
		}
		else if (authStore.userInfoMyVTC) {
			authStore.username = authStore.userInfoMyVTC.AccountName;
			this.$router.push({ name: 'confirmlogin', params: {} });
		}
		else {
			this.$router.push({ name: 'username', params: {} });
		}
	}
};
</script>
<style>
@import url(~@/assets/css/form.css);
.blur{
   opacity: .6;
}

.blur:hover{
     background: var(--cyan, #248ef9)!important;
      cursor: not-allowed;
}

input:focus {
  border-top: solid 1px #2b92fa;
  border-bottom: solid 1px #2b92fa;
  border-right: solid 1px #2b92fa;
}
</style>